import { SubmitForm } from "../../../../../Syntess.Web.Shared/Core";
import { i18n } from "../../../../../Syntess.Web.Shared/I18n";
import * as I18nKeysShared from "../../../../../Syntess.Web.Shared/Locales/shared-map.json";
import { IDialogButton } from "./IDialogButton";

export class LoginViewModel {
    public toonVraag = ko.observable(false);
    public buttons: IDialogButton[] = [];

    constructor(private window: Window) {
        this.buttons.push({
            text: i18n.t(I18nKeysShared.login.button.verderGaan),
            click: () => this.continueWithSameUser()
        });

        this.buttons.push({
            text: i18n.t(I18nKeysShared.login.button.opnieuwInloggen),
            cta: true,
            click: () => this.logout()
        })
    }

    public toonVraagOpnieuwInloggen(): void {
        this.toonVraag(true);
    }

    private logout(): void {
        SubmitForm('logout1', 'Click');
    }

    private continueWithSameUser(): void {
        this.window.location.href = this.window.location.href.replace("Login.aspx", "AdminPage.aspx");
    }
}
